
import { defineComponent } from 'vue';

import { AutoComplete } from 'mq-ui-kit/lib/AutoComplete';
import { Button } from 'mq-ui-kit/lib/Button';
import { FormRow } from 'mq-ui-kit/lib/FormRow';
import { FormControlModel } from 'mq-ui-kit/lib/form-control-model';
import ToastService from 'mq-ui-kit/lib/toast';

import campaignService, { Campaign } from '@/services/campaign.service';
import * as Actions from '@/store/actions';

import PoweredBy from '@/components/PoweredBy/PoweredBy.vue';
import { Validators } from 'mq-ui-kit/lib/form-validate';

export default defineComponent({
  name: 'ChooseProject',

  components: {
    AutoComplete,
    FormRow,
    Button,
    PoweredBy,
  },

  data() {
    return {
      logoIcon: require('@/assets/icons/mep-text-logo.svg'),

      autoCompleteData: {
        items: [] as Campaign[],
        itemText: 'name',
        itemValue: 'id',
      },

      campaign: new FormControlModel({
        validations: [Validators.required()],
        messages: {
          required: this.$t('chooseProject.campaignMandatory'),
        },
      }),

      preSelectedUtmCode: '',
    };
  },

  computed: {
    utmCode(): string {
      return this.$route.query.utmcode as string;
    },

    inValid(): boolean {
      return !this.campaign.valid;
    },
  },

  created() {
    this.preSelectedUtmCode = this.$route.query.utmcode as string;
    this.getCampaigns();
  },

  watch: {
    utmCode() {
      this.preSelectedUtmCode = this.utmCode;
      this.loadDefaultCampaign();
    },
  },

  methods: {
    getCampaigns() {
      const promise = campaignService.getCampaigns();

      promise.then((campaigns) => {
        this.autoCompleteData.items = campaigns;
        this.loadDefaultCampaign();
      })
        .catch(() => {
          ToastService.errorToast(this, this.$t('chooseProject.errorCampaignListLoad'));
        });
    },

    loadDefaultCampaign() {
      if (this.preSelectedUtmCode) {
        const matchedCampaign = this.getMatchedCampaignForCode(
          this.autoCompleteData.items, this.preSelectedUtmCode,
        );

        if (matchedCampaign) {
          this.campaign.setValue(matchedCampaign);
          this.saveCampaignInStore(matchedCampaign);
        }
      } else if (this.$store.state.campaign) {
        this.campaign.setValue(this.$store.state.campaign);
      } else {
        const promise = campaignService.getDefaultCampaign();
        promise.then((campaign) => {
          this.$store.dispatch(Actions.SET_SELECTED_CAMPAIGN, campaign);
          this.campaign.setValue(this.$store.state.campaign);
        })
          .catch(() => {
            ToastService.errorToast(this, this.$t('chooseProject.errorCampaignListLoad'));
          });
      }
    },

    getMatchedCampaignForCode(campaigns: Campaign[], code: string): Campaign | null {
      let foundCampaign: Campaign | null = null;
      campaigns.forEach((item) => {
        if (item.campaignCode === code) {
          foundCampaign = item;
        }
      });

      return foundCampaign;
    },

    onCampaignSelect(value: Campaign) {
      this.saveCampaignInStore(value);
    },

    saveCampaignInStore(value: Campaign) {
      this.$store.dispatch(Actions.SET_SELECTED_CAMPAIGN, value);
    },

    confirmCampaign() {
      this.$router.push({
        name: 'YourData',
      });
    },
  },
});
